export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--B.de61a24f.png";